import { render, staticRenderFns } from "./BaseFillupPos.vue?vue&type=template&id=f784f7ce&"
import script from "./BaseFillupPos.vue?vue&type=script&lang=js&"
export * from "./BaseFillupPos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports